<template>
  <div>
    <div class="container">
      <v-card>
        <v-stepper v-model="stepGuide" alt-labels>
          <v-stepper-header>
            <v-stepper-step step="1" :complete="stepGuide > 1"
              ><span class="text-center"
                >Información de identificación médica</span
              >
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="2" :complete="stepGuide > 2"
              ><span class="text-center">Información general</span>
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="2" :complete="stepGuide > 3"
              ><span class="text-center">Información de contacto</span>
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="3" :complete="stepGuide > 4"
              ><span class="text-center">Antecedentes no patológicos</span>
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="4" :complete="stepGuide > 5"
              ><span class="text-center">Adjuntos</span>
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="5" :complete="stepGuide > 6"
              ><span class="text-center">Información de cita</span>
            </v-stepper-step>
          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content step="1">
              <MedicalIdentityForm
                :medicalIdentityData="medicalIdentityData"
                @nextstep="nextstep"
              />
            </v-stepper-content>
            <v-stepper-content step="2">
              <GeneralInfoForm
                :generalInfoData="generalInfoData"
                @laststep="laststep"
                @nextstep="nextstep"
              />
            </v-stepper-content>
            <v-stepper-content step="3">
              <ContactForm />
            </v-stepper-content>
            <v-stepper-content step="4">
              <NoPatologicPanel
                :noPatologicData="noPatologicData"
                @laststep="laststep"
                @nextstep="nextstep"
              />
            </v-stepper-content>
            <v-stepper-content step="5">
              <AttachmentsForm
                :attachmentsData="attachmentsData"
                @laststep="laststep"
                @nextstep="nextstep"
              />
            </v-stepper-content>
            <v-stepper-content step="6">
              <FormSpeciality @updateList="updateList" />
              <v-container>
                <template v-if="appointmentsList.length > 0">
                  <v-row>
                    <v-col cols="12" md="12" sm="12">
                      <AppointmentsTablexUser
                        :appointmentsList="appointmentsList"
                        :deleteAppointment="deleteAppointment"
                      />
                    </v-col>
                  </v-row>
                </template>
              </v-container>
              <!-- <buttonstepper @laststep="laststep" @nextstep="nextstep" /> -->
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card>
      <template v-if="flagSave == true">
        <AppointmentSometryModal
          :addDate="addDate"
          :dialogAppointment="dialogAppointment"
          @changeSometometry="changeSometometry"
          @dialogClose="dialogClose"
        />
      </template>
    </div>
  </div>
</template>

<script>
import CameraSuim from "@/components/CameraSuim.vue";
import FormSpeciality from "@/app/components/reception/speciality/FormSpeciality.vue";
import AppointmentSometryModal from "@/app/components/reception/AppointmentSometryModal.vue";
import AppointmentsTablexUser from "@/app/components/reception/AppointmentsTablexUser.vue";
import NoPatologicPanel from "@/app/components/reception/componentsFormReception/NoPatologicPanel.vue";
import AttachmentsForm from "@/app/components/reception/componentsFormReception/AttachmentsForm.vue";
import GeneralInfoForm from "@/app/components/reception/componentsFormReception/GeneralInfoForm.vue";
import MedicalIdentityForm from "@/app/components/reception/componentsFormReception/MedicalIdentityForm.vue";
import ContactForm from "@/app/components/reception/componentsFormReception/ContactForm.vue";
import buttonstepper from "@/app/components/reception/componentsFormReception/buttonstepper.vue";

export default {
  name: "PatientForm",
  props: {
    model: Object,
    stepChange: Number,
  },
  components: {
    CameraSuim,
    FormSpeciality,
    AppointmentSometryModal,
    AppointmentsTablexUser,
    NoPatologicPanel,
    AttachmentsForm,
    GeneralInfoForm,
    MedicalIdentityForm,
    ContactForm,
    buttonstepper,
  },
  data() {
    return {
      stepGuide: 1,
      generalInfoData: {},
      appointmentsList: [],
      noPatologicData: {},
      attachmentsData: {},
      medicalIdentityData: {},
      flagSave: false,
      dialogAppointment: false,
    };
  },
  methods: {
    updateList(list) {
      this.appointmentsList = list;
      this.model.Appointment = list;
      this.activeButton = false;
    },
    deleteAppointment(index) {
      this.appointmentsList.splice(index, 1);
    },
    changeSometometry(e) {
      this.sometriaChoose = e;
    },
    dialogClose(e) {
      this.dialogAppointment = e;
    },
    nextstep(a) {
      this.stepGuide = a;
    },
    laststep(a) {
      this.stepGuide = a;
    },
  },
};
</script>
